import http from './http.service';

class PricelistService {
    constructor() {
        if (PricelistService.instance) {
            return PricelistService.instance;
        }

        PricelistService.instance = this;
    }

    pricelists() {
        return http.get('/pricelist').then(res => res.data);
    }
    store(data) {
        return http.post('/pricelist/store', data).then(res => res.data);
    }
    update(pricelistId, data) {
        return http.put(`/pricelist/${pricelistId}/update`, data).then(res => res.data);
    }
    toggleActive(pricelistId) {
        return http.put(`/pricelist/${pricelistId}/toggle-active`).then(res => res.data);
    }
    destroy(pricelistId) {
        return http.delete(`/pricelist/${pricelistId}/destroy`).then(res => res.data);
    }
}

export default new PricelistService();
